/** Workbench user administration (`/admin/users`), as the backend sends it. */

import type { components } from "@/lib/api-schema";

type Schemas = components["schemas"];

export type UserStatus = "active" | "deactivated";

export type UserRow = Schemas["UserRowOut"];
export type UserProject = Schemas["UserProjectOut"];
export type UserDetail = Schemas["UserDetailOut"];
export type UserPage = Schemas["UserPageOut"];

export const statusOf = (u: UserRow): UserStatus => (u.deactivated_at ? "deactivated" : "active");
